import { defineFcm } from '../shared/factory';

export const FCM_STICKY_SIGNATURE_BLOCK = defineFcm('sticky_signature_block').asBoolean().withDefault(false).toConfig();
